import React, { useContext, useState, useRef, useEffect } from 'react';
import { SettingsBannerContext } from '../../contexts/SettingsBannerContext';
import { MasterBannerContext } from '../../contexts/MasterBannerContext';
import Element from './Element';
import './index.css';
import { CreateHash } from '../../helpers/buildBanner'
import { AuthValidatorContext } from '../../contexts/auth';
import Tooltip from '@mui/material/Tooltip';
import { generateUUID } from '../../helpers/assets'
import { base64ToBlob } from '../../helpers/exportBanner';
import { convertBlobToBase64 } from '../../helpers/fileManager';

function Layer() {
  const { layerActive, setLayerActive, setReload, setFullScreenLeft, fullScreenLeft } = useContext(SettingsBannerContext);
  const { master, setMaster, assets, setAssets } = useContext(MasterBannerContext);
  const [ menu, setMenu ] = useState(null);
  const { setAuth } = useContext(AuthValidatorContext);
  const refInputAsset = useRef(null);
  var dragElement = 0;
  var indexDrag = -1;
  var stepDrag = -1;
  // if (layerActive.length === 0 && master !== null && master.elements !== null) setLayerActive([{element: master.elements[0], type: "in"}]);
  const handleDrag = (ev) => {
    dragElement = ev.target.id.replace("layer-element-", "");
    indexDrag = master.elements.findIndex(el => el.id === dragElement);
    stepDrag = master.elements[indexDrag].step;
  };

  const handleDrop = (ev) => {
    ev.currentTarget.style.background = 'none';
    var masterCopy = JSON.parse(JSON.stringify(master));
    
    var dropElement = ev.currentTarget.id.replace("layer-element-", "");
    var indexDrop = masterCopy.elements.findIndex(el => el.id === dropElement);

    const parentElementDrop = masterCopy.elements[indexDrop].parent;
    const parentElementDrag = masterCopy.elements[indexDrag].parent;
    const elementDrag = masterCopy.elements[indexDrag];
    
    if (parentElementDrop !== parentElementDrag) return;

    var stepDrop = masterCopy.elements[indexDrop].step;
    if (stepDrop === stepDrag) {
      masterCopy.elements[indexDrag].order = masterCopy.elements[indexDrop].order;
      masterCopy.elements[indexDrop].order = masterCopy.elements[indexDrag].order + 0.5;
      masterCopy.elements = orderElements(masterCopy.elements);
      setMaster(masterCopy);
      setLayerActive([{element: elementDrag, type: "in"}])
      setReload(true);
    } else {
      dragElement = 0;
      indexDrag = -1;
      stepDrag = -1;
    }
  };


  function orderElements(elements) {
    elements.sort(function(a, b) {
      return a.order - b.order;
    });
    var order = 1;
    elements.forEach(element => {
      if (!element.parent) {
        element.order = order;
        order++;
        elements.forEach(children => {
          if (element.id === children.parent) {
            children.order = order;
            order++;
          }
        });
      }
    });
    elements.sort(function(a, b) {
      return a.order - b.order;
    });
    return elements;
  }

  const handleDragOver = (ev) => {
    ev.preventDefault();
    var dragOver = ev.currentTarget.id.replace("layer-element-", "");
    var indexOver = master.elements.findIndex(el => el.id === dragOver);
    var stepOver = master.elements[indexOver].step;
    if (stepOver === stepDrag && master.elements[indexOver].parent === master.elements[indexDrag].parent) {
      // ev.currentTarget.style.background = 'aquamarine';
      ev.currentTarget.style.borderTop = "2px solid red";
    }
    else ev.currentTarget.style.background = 'red';
  }

  const handleDragLeave = (ev) => {
    ev.preventDefault();
    ev.currentTarget.style.borderTop = "2px solid transparent";
    ev.currentTarget.style.background = 'none'
  }

  var previewStyle = "width";

  try {
    if (layerActive.length === 1) {
      var size = layerActive[0].element.properties.width / layerActive[0].element.properties.height;
      if (size < 1.5) {
        previewStyle = "height";
      }
    }
  } catch (error) {}

  const qteChildrens = (parent) => {
    var count = 0;
    master.elements.forEach(el => {
      if (el.parent === parent) count++;
    });
    return count;
  }

  function activeFilterElementId (id, arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].element.id === id) {
        return arr[i].element.id;
      }
    }
    return false;
  }

  async function updateAsset(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      if (file.type.startsWith('video/')) {
        const url = URL.createObjectURL(file);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        let size = {
          width: 0,
          height: 0
        }
        
        video.onloadedmetadata = function() {
          URL.revokeObjectURL(url);
          size.width = video.videoWidth;
          size.height = video.videoHeight;
          const videoReader = new FileReader();
          videoReader.readAsDataURL(file);
          videoReader.onload = function () {
            const b64 = videoReader.result;            
            var masterCopy = JSON.parse(JSON.stringify(master));
            var listAssets = JSON.parse(JSON.stringify(assets));

            try {
              if (!listAssets || listAssets.length === 0 || listAssets === null || listAssets === undefined || listAssets === "undefined") {
                listAssets = [];
                masterCopy.elements.forEach(element => {
                  const index = listAssets.findIndex(obj => obj.uuid === element.properties.asset);
                  if (index === -1) {
                    if (element.properties.background) {
                      listAssets.push({
                        uuid: element.properties.asset,
                        data: element.properties.background
                      });
                    } else if (element.properties.originalBackground) {
                      listAssets.push({
                        uuid: element.properties.asset,
                        data: element.properties.originalBackground
                      });
                    } else if (element.properties.blob) {
                      convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                        listAssets.push({
                          uuid: element.properties.asset,
                          data: b64
                        });
                      });
                    }
                  }
                });  
              }
            } catch (error) {
              console.log('Error ao processar assets com lista vazia', error);
            }
            const uuid = generateUUID();
            listAssets.push({
              uuid: uuid,
              data: b64
            })
            
            for (var i = 0; i < masterCopy.elements.length; i++) {
              if (masterCopy.elements[i].id === activeFilterElementId(masterCopy.elements[i].id, layerActive)) {
                masterCopy.elements[i].properties.background = b64;
                masterCopy.elements[i].properties.originalBackground = b64;
                masterCopy.elements[i].properties.asset = uuid;
                const blob = base64ToBlob(b64);
                const blobUrl = URL.createObjectURL(blob);
                masterCopy.elements[i].properties.blob = blobUrl;
                masterCopy.elements[i].properties.type = 'video';
                masterCopy.elements[i].properties.width = size.width;
                masterCopy.elements[i].properties.height = size.height;
                masterCopy.hash = CreateHash(masterCopy);
                setMaster(masterCopy);
                setLayerActive(layerActive);
                setReload(true);
                setAssets(listAssets);
                break;
              }
            }
          };
          videoReader.onerror = function (error) {
            return null;
          };
          return;
        };
        
      } else {
        var img = new Image();
        img.onload = function() {
          const width = img.width;
          const height = img.height;        
          const b64 = reader.result;
          var masterCopy = JSON.parse(JSON.stringify(master));
          var listAssets = JSON.parse(JSON.stringify(assets));

          try {
            if (!listAssets || listAssets.length === 0 || listAssets === null || listAssets === undefined || listAssets === "undefined") {
              listAssets = [];
              masterCopy.elements.forEach(element => {
                const index = listAssets.findIndex(obj => obj.uuid === element.properties.asset);
                if (index === -1) {
                  if (element.properties.background) {
                    listAssets.push({
                      uuid: element.properties.asset,
                      data: element.properties.background
                    });
                  } else if (element.properties.originalBackground) {
                    listAssets.push({
                      uuid: element.properties.asset,
                      data: element.properties.originalBackground
                    });
                  } else if (element.properties.blob) {
                    convertBlobToBase64(base64ToBlob(element.properties.blob)).then((b64) => {
                      listAssets.push({
                        uuid: element.properties.asset,
                        data: b64
                      });
                    });
                  }
                }
              });  
            }
          } catch (error) {
            console.log('Error ao processar assets com lista vazia', error);
          }

          const uuid = generateUUID();
          listAssets.push({
            uuid: uuid,
            data: b64
          });

          for (var i = 0; i < masterCopy.elements.length; i++) {
            if (masterCopy.elements[i].id === activeFilterElementId(masterCopy.elements[i].id,layerActive)) {
              masterCopy.elements[i].properties.background = b64;
              masterCopy.elements[i].properties.originalBackground = b64;
              masterCopy.elements[i].properties.asset = uuid;
              const blob = base64ToBlob(b64);
              const blobUrl = URL.createObjectURL(blob);
              masterCopy.elements[i].properties.blob = blobUrl;
              masterCopy.elements[i].properties.width = width;
              masterCopy.elements[i].properties.height = height;
              masterCopy.hash = CreateHash(masterCopy);            
              setMaster(masterCopy);
              setLayerActive(layerActive)
              setReload(true);
              setAssets(listAssets);
              break;
            }
          }
        };
        img.src = reader.result;
      }

      
    };
    reader.onerror = function (error) {
      return null;
    };
  }

  const toggleLayer = (ev) => {
  }

  const [collapsedDivs, setCollapsedDivs] = useState([]);
  
  const handleCollapse = (step) => {
    const divsUpdated = [...collapsedDivs];
    divsUpdated[step] = !divsUpdated[step];
    setCollapsedDivs(divsUpdated);
  };

  const [divWidth, setDivWidth] = useState('330px')

  useEffect(() => {
    function handleResize() {
      if (!fullScreenLeft) {
        const windowWidth = window.innerWidth;
        if (windowWidth >= 1900) {
          setDivWidth('330px');
        } else if (windowWidth >= 1600) {
          setDivWidth('310px');
        } else if (windowWidth >= 1300) {
          setDivWidth('290px');
        } else if (windowWidth >= 1200) {
          setDivWidth('280px');
        } else {
          setDivWidth('330px');
        }
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [fullScreenLeft]);

	return (
		<div
      className="container-layer"
      style= {{
        width: fullScreenLeft ? '0px' : divWidth,
        transition: 'width 500ms'
      }}
      onClick={() => setMenu(null)}
    >
      <div className='projectNameandNew'>
        <span className='projectName'>{ master.psd.slice(0, -4) }</span>
        <Tooltip  title="Novo projeto">
          <img src="assets/addbutton.png" style={{cursor: 'pointer'}}
            onClick={() => {
              document.getElementById('file-dropzone').click();
              setAuth(true);
              }}>
          </img>
        </Tooltip>
      </div>
      <div className='collapseLayer'
        style= {{
        right: fullScreenLeft ? '-15px' : '-10px',
        transform: fullScreenLeft ? 'scaleX(-1)' : 'scaleX(1)',
        transition: 'left 500ms'
        }}
        onClick={() => setFullScreenLeft(!fullScreenLeft)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <g id="Group_733" data-name="Group 733" transform="translate(-5890 9764)">
            <g id="Ellipse_33" data-name="Ellipse 33" transform="translate(5890 -9764)" fill="#1B9ADA" stroke="#1B9ADA" stroke-width="1">
              <circle cx="10" cy="10" r="10" stroke="none"/>
              <circle cx="10" cy="10" r="9.5" fill="none"/>
            </g>
            <path id="Path_538" data-name="Path 538" d="M0,0,4.5,5.143,9,0" transform="translate(5901.665 -9758.474) rotate(90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          </g>
        </svg>
      </div>
      { master ?
      <>
      <div style={{width: '100%'}}>
        <span className='camadasText'>Camadas</span>
        <div className="layer-preview" id="layer-preview">
          {layerActive.length === 1 ?
        <img
          alt="preview"
          src={layerActive[0].element.properties.blob ? layerActive[0].element.properties.blob : layerActive[0].element.properties.originalBackground}
          style={{
            width: previewStyle === 'width' ? '100px' : '',
            height: previewStyle === 'height' ? '100px' : '',
            boxShadow: '1px 2px 5px 1px #444444'
          }}></img>
          : <></> }
        </div>
      </div>
      <input
        onChange={(e) => updateAsset(e.target.files[0])}
        ref={refInputAsset}
        accept=".jpg, .png, .jpeg, .bmp, .tif, .tiff|image/*, .mp4"
        type='file'
        style={{display: 'none'}}
      />
      <div className="container-list-layers">
        { master ? master.elements.map((layer, item) => (
          <div
            key={Math.random()}
            style={{display: 'flex', flexDirection: 'column', margin: '0 10px 0 5px', alignItems: 'baseline', padding: '0px 15px', position: 'relative'}}>
              { item === 0 ||  master.elements[item - 1].step !== master.elements[item].step ?
              <div style={{color: '#222222', fontSize: '14px', fontWeight: 'bold', overflow: 'hidden', width: '270px', borderBottom: '1px solid rgba(112, 112, 112, .4)',
                margin: '0px 0 5px 0', display: 'flex', justifyContent: 'space-between'}} onClick={() => toggleLayer(layer.step)}>
                  <span style={{color: '#222222', fontSize: '14px', fontWeight: 'bold', overflow: 'hidden', margin: '5px 0 0 0'}}>Step {layer.step}</span>
                  {
                      collapsedDivs[layer.step] ? <img src="assets/arrownew.png" onClick={() => handleCollapse(layer.step)} 
                      style={{transform: "rotate(180deg)", padding: '5px', width: '11px', height: '7px', margin: '20px 0 0 0', cursor: 'pointer'}}/> 
                      : <img src="assets/arrownew.png" onClick={() => handleCollapse(layer.step)} style={{padding: '5px', width: '11px', height: '7px', margin: '20px 0 0 0', cursor: 'pointer'}}/>
                    }
                  </div>
                : <></> }
                { !layer.parent ?
                  <>
                    <div className='layer-group' style={{display: layer.children  ? 'flex' : 'none'}}></div>
                    {
                      !collapsedDivs[layer.step] && (
                    <div
                      id={`layer-element-${layer.id}`} 
                      draggable={true}
                      onDragOver={handleDragOver}
                      onDragStart={handleDrag}
                      onDrop={handleDrop}
                      onDragLeave={handleDragLeave}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        position: 'relative',
                        borderTop: '2px solid transparent'
                      }}
                      >
                      <svg height={qteChildrens(layer.id) * 60}  width="10" style={{display: layer.children ? 'flex' : 'none', position: 'absolute', left: '10px', top: '30px'}}>
                        <line x1="0" y1="0" x2="0" y2={qteChildrens(layer.id) * 60 - 32} style={{stroke:'rgb(255,0,0)', strokeWidth:'2'}}></line>
                      </svg>
                      <Element
                        onClick={(evt) => {
                          setMenu(layer);
                          setLayerActive([{element: layer, type: "in"}]);
                        }}
                        layerActive={layerActive[0].element}
                        layer={layer}
                      />
                      <div
                        style={{
                          display: menu === layer ? 'flex' : 'none',
                          width: '150px',
                          height: '35px',
                          background: 'white',
                          position: 'absolute',
                          top: 40,
                          left: 60,
                          zIndex: 999,
                          border: '1px solid #aba9a9',
                          borderRadius: '5px',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                        <div
                          style={{
                            textAlign: 'center',
                            width: '90%',
                            borderRadius: '15px',
                            cursor: 'pointer'
                          }}
                          className="layer-item"
                        >
                          <span
                            style={{color: '#707070'}}
                            onClick={() => refInputAsset.current.click()}
                          >
                            Alterar Asset
                          </span>
                        </div>
                      </div>
                    </div>
                      )}
                    {layer.children ?
                      master.elements.map(children =>
                        children.parent === layer.id ?
                        <div
                          key={Math.random()}
                          id={`layer-element-${children.id}`} 
                          draggable={true}
                          onDragOver={handleDragOver}
                          onDragStart={handleDrag}
                          onDrop={handleDrop}
                          onDragLeave={handleDragLeave}
                          style={{display: 'flex', justifyContent: 'flex-end', position: 'relative'}}
                          >                            
                          <svg height="5px" width="20" style={{display: layer.children ? 'flex' : 'none', position: 'absolute', left: '10px', top: '30px'}}>
                            <line x1="0" y1="0" x2="20" y2="0" style={{stroke:'rgb(255,0,0)', strokeWidth:'2'}}></line>
                          </svg>
                          <Element layerActive={layerActive[0].element} layer={children}/>
                        </div>
                        : <></>
                      )
                      : <></>
                    }
                  </>
                  : <></>
                }
          </div>
        )) : null}
      </div> 
      </>
      : 
      <></> 
      }
		</div>
	)
}
 export default Layer;